import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { FieldRow, InfoTip, SegmentedControl } from '@/core/ui';
import { trailsVisibilityAtom } from './trailsAtom';

/** Shows or hides hiking paths and tracks. */
export function TrailsField() {
  const { t } = useTranslation('trails');
  const [visibility, setVisibility] = useAtom(trailsVisibilityAtom);
  return (
    <FieldRow group label={t('label')} info={<InfoTip label={t('help')}>{t('legend')}</InfoTip>}>
      <SegmentedControl
        compact
        className="min-w-[130px]"
        options={[
          { value: 'off', label: t('off') },
          { value: 'on', label: t('on') },
        ]}
        value={visibility}
        onChange={setVisibility}
      />
    </FieldRow>
  );
}
